<template>
    <v-navigation-drawer v-model="navigationDialog" right temporary="" fixed app :hide-overlay="true" width="400" stateless>
        <v-toolbar flat height="60" dark color="accent">
            <v-toolbar-title class="font-weight-medium">
              <v-icon @click="closeDrawer()">fa fa-arrow-left</v-icon>
            </v-toolbar-title>
            <v-toolbar-items>
                <p class="pl-5 pt-4 title white--text">Notifications
                </p>
            </v-toolbar-items>
         </v-toolbar>
  <v-card flat >
    <v-layout wrap>
     <v-flex class="pa-4">
       <v-card @click="$router.push({name: 'DeviceList', params:{title: 'notifications'}})">
         <v-layout wrap>
         <v-flex xl3 lg3 md3 class="text-center" :style="`background-color:#1976d2 `">
           <v-icon color="white" class="pa-5">fa fa-laptop</v-icon>
         </v-flex>
         <v-flex xl9 lg9 md9 class="text-right px-3">
           <p class="pt-4 primary--text font-weight-medium title">Device
             <span class="red--text title">(30)</span>
           </p>
         </v-flex>
         </v-layout>
       </v-card>
         </v-flex>

         <v-flex class="px-4 pb-4">
       <v-card @click="$router.push({name: 'DeviceList', params:{title: 'notifications'}})">
         <v-layout wrap>
         <v-flex xl3 lg3 md3 class="text-center" :style="`background-color:#1976d2 `">
           <v-icon color="white" class="pa-5">fa fa-comments</v-icon>
         </v-flex>
         <v-flex xl9 lg9 md9 class="text-right px-3">
           <p class="pt-4 primary--text font-weight-medium title">Communication
             <span class="red--text title">(20)</span>
           </p>
         </v-flex>
         </v-layout>
       </v-card>
         </v-flex>
    </v-layout>
      </v-card>
    </v-navigation-drawer>
</template>

<script>
import Nowak from '@/api/Nowak'
export default {
  data () {
    return {
      navigationDialog: true,
      deviceObj: {}
    }
  },
  mounted () {
    this.getNotifiocations()
  },
  methods: {
    closeDrawer () {
      this.$root.$emit('Closedrawer', {
        closeDrawer: false
      })
    },
    getNotifiocations () {
      // this.$store.dispatch('SetLoader', {status: true, message: 'Loading ...'})
      // let communicationTypeSlug = 'device'
      // Nowak.GetNotificationForDevice(
      //   communicationTypeSlug,
      //   response => {
      //     console.log('Notifications', response)
      //     this.$store.dispatch('SetLoader', {status: false, message: 'Loading ...'})
      //   //   console.log(JSON.parse(response.Data[11].notificationPayload), 'notificationPayload')
      //     let deviceDetails = JSON.parse(response.Data[11].notificationPayload)
      //     let Obj = {
      //         employeeId: 1,
      //         deviceId: 0,
      //         deviceName: deviceDetails.deviceName,
      //         deviceType: deviceDetails.deviceType,
      //         deviceVersion: deviceDetails.deviceVersion,
      //         isActive: deviceDetails.isActive,
      //         deviceNotes: deviceDetails.deviceNotes,
      //         deviceMacDetails: [{
      //             deviceMacAddress: deviceDetails.deviceMacAddress,
      //             deviceMacNotes: '',
      //             isActive: true
      //         }]
      //     }
      //     this.deviceObj = Obj
      //   },
      //   error => {
      //     console.log('err', error)
      //     this.$store.dispatch('SetLoader', {status: false, message: 'Loading...'})
      //     this.$store.dispatch('SetAlert', {showAlert: true, message: error.message, color: 'error'})
      //   }
      // )
    },
    approveDevice () {
      this.$store.dispatch('SetLoader', {status: true, message: 'Loading ...'})
      let notificationId = 12
      Nowak.AcceptDeviceNotification(
        this.deviceObj,
        notificationId,
        response => {
          console.log('AcceptDeviceNotification', response)
          this.$store.dispatch('SetLoader', {status: false, message: 'Loading ...'})
        },
        error => {
          console.log('err', error)
          this.$store.dispatch('SetLoader', {status: false, message: 'Loading...'})
          this.$store.dispatch('SetAlert', {showAlert: true, message: error.message, color: 'error'})
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/View/HRM/layout/NotificationDrawer.vue